import React from 'react';

const IconUpOutlined = () => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      id="Vector 1355"
      d="M9 5L5 1L1 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconUpOutlined;
